import clsx from 'clsx'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface TryButtonProps {
  withShadow?: boolean
  text?: string
  to?: string
  onClick?: () => void
  disabled?: boolean
  isWhitePage?: boolean
}

const TryButton = (props: TryButtonProps) => {
  const navigate = useNavigate()
  return (
    <button
      onClick={props.onClick ? props.onClick : () => navigate(props.to ?? '/scan-results')}
      disabled={props.disabled}
      className={clsx(
        'text-center w-full h-14 py-2.5 px-4 rounded-4xl text-white dark:text-black bg-buttonGradient text-L font-bold transition-colors duration-200',
        {
          'shadow-[10px_10px_50px_0px_rgba(253,211,62,0.4)] ': props.withShadow,
          'bg-disabledButtonGradient transition-colors duration-200': props.disabled,
        },
      )}
    >
      {props.text ?? 'Try Clean Master Now'}
    </button>
  )
}

export default TryButton
